import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/Button';
import Checklist from '../../components/Checklist';
import Content from '../../components/Content';
import { H3 } from '../../components/Heading';
import { IconArrowRight } from '../../components/Icon';
import Modal from '../../components/Modal';
import { Sheet } from '../../components/Sheet';
import { Stack, StackLarge } from '../../components/Stack';
import { Text } from '../../components/Text';

interface Props {
  trackOnSignInClick?: () => void;
  trackOnInit?: () => void;
  onClose: () => void;
  image?: string;
  title: string;
  text?: string;
  to?: string;
  loginButtonTestId?: string;
}
const SignInModal = ({
  trackOnSignInClick,
  trackOnInit,
  onClose,
  image,
  title,
  text,
  to,
  loginButtonTestId,
}: Props) => {
  const { t } = useTranslation(['global', 'loginModal']);
  const defaultTo = `/auth/signin?redirectUrl=${location.pathname}`;

  useEffect(() => {
    if (trackOnInit) {
      trackOnInit();
    }
  }, []);

  return (
    <Modal
      onClose={onClose}
      illustration={
        image
          ? {
              src: image,
              alt: title,
            }
          : undefined
      }
    >
      <StackLarge>
        <Text $align="center">
          <H3>{title}</H3>
          <Content>
            <p>{text || t('loginModalDescription', { ns: 'loginModal' })}</p>
          </Content>
        </Text>
      </StackLarge>
      <StackLarge>
        <Button
          as="a"
          href={to || defaultTo}
          onClick={trackOnSignInClick}
          $tone="primary"
          $fullWidth
          title={
            t('loginTitle', { ns: 'loginModal', brandName: t('brandName', { ns: 'global' }) }) || ''
          }
          data-testid={loginButtonTestId}
        >
          {t('loginOrSignup', { ns: 'loginModal' })}
          <IconArrowRight />
        </Button>
      </StackLarge>
      <StackLarge>
        <Sheet $gutter="small">
          <Stack>
            <Text $weight="medium">
              {t('uspHeading', { ns: 'loginModal', brandName: t('brandName', { ns: 'global' }) })}
            </Text>
          </Stack>
          <Stack>
            <Checklist
              items={[
                t('uspOne', { ns: 'loginModal' }),
                t('uspTwo', { ns: 'loginModal' }),
                t('uspThree', { ns: 'loginModal' }),
                t('uspFour', { ns: 'loginModal' }),
              ]}
            />
          </Stack>
        </Sheet>
      </StackLarge>
    </Modal>
  );
};

export default SignInModal;
